import { useShopStatusStore } from "@/abilities/shop/features/shop-core/store/shop-status.store";
import { ShopCore } from "@/abilities/shop/types/shop-core";
import { ref } from "vue";
import { createShopApolloClient } from "../../shop-core/helper/create-shop-apollo-client";
import { useSapAuth } from "./use-sap-auth";

// Create singleton instance that persists across component lifecycles
const clientContainer = ref<ShopCore.ClientWithCache | undefined>(undefined);

export function useSapClient() {
    const { getAccessToken } = useSapAuth();

    const getClient = async () => {
        const store = useShopStatusStore();
        const { graphUrl } = store.sapConfig() ?? {};

        if (!graphUrl) {
            throw new Error("Base URL is not defined");
        }

        if (!clientContainer.value) {
            clientContainer.value = createShopApolloClient(graphUrl, {
                accessToken: getAccessToken(),
            });
        }

        return clientContainer.value?.client;
    };

    const resetClient = (): void => {
        clientContainer.value = undefined;
    };

    return {
        getClient,
        resetClient,
    };
}
